import type { ReactNode, CSSProperties, FC, HTMLAttributes } from 'react';
import { forwardRef } from 'react';
import classnames from 'classnames';

import PageHead from 'app/components/PageHead';

import { isProdDataInLocal } from './utils';
import style from './style.scss';

interface MainContentProps {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  style?: CSSProperties;
  title?: string;
  subtitle?: string;
  display?: 'full_page' | 'frame' | 'no-frame';
}

const AppContainer: FC<HTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => (
  <div
    className={classnames(style.appContainer, className, {
      [style.prodDataInDev]: isProdDataInLocal()
    })}
    {...props}
  />
);

const MainContent = forwardRef<HTMLDivElement, MainContentProps>(
  (
    {
      children = false,
      className,
      contentClassName: propContentClassName,
      style: css,
      title,
      subtitle,
      display = 'frame'
    },
    ref
  ) => {
    const containerClassName = classnames(style.mainContainer, className, {
      [style.mainContainer_fullWidth]: display === 'full_page',
      [style.mainContainer_noFrame]: display === 'no-frame'
    });
    const contentClassName = classnames(style.mainContent, propContentClassName, {
      [style.mainContent_fullWidth]: display === 'full_page',
      [style.mainContent_noFrame]: display === 'no-frame'
    });

    return (
      <div ref={ref} className={containerClassName} style={css}>
        <div className={contentClassName}>
          {title && <PageHead title={title} subtitle={subtitle} />}
          {children}
        </div>
      </div>
    );
  }
);

MainContent.displayName = 'MainContent';

export { AppContainer, MainContent };
